import { Button } from "antd";
import classes from "./Jobs.module.css";

const JobDownloadButton = ({ data, filename }: {data: any, filename: string}) => {
  const handleDownload = () => {
    const jobData = JSON.stringify(data);
    const blob = new Blob([jobData], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}.json`;
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Button
        onClick={() => handleDownload()}
        className={classes.JVDownloadButton}
        style={{ backgroundColor: "#283583"}}
    >
        Download Job
    </Button>
  );
};

export default JobDownloadButton;